import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { LabelContainer, LabelDiv } from './Label.css';
const Label = ({ label, value, color }) => (_jsxs(LabelContainer, { children: [_jsx(LabelDiv, { color: color }), _jsxs("div", { children: [_jsx(Typography, { children: label }), _jsx(Typography, Object.assign({ style: { fontWeight: 'bold', marginTop: '-5px' } }, { children: value }))] })] }));
export default Label;
